import React from 'react'
import EnrollBAnner from '../components/Enroll-course-banner'
import WebinarFormPopup from './../components/WebinarFormPopup';

const Enroll = () => {
  return (
    <div>
        <EnrollBAnner/>
        <WebinarFormPopup/>
    </div>
  )
}

export default Enroll